import { render, staticRenderFns } from "./InventoryPrivilegeList.vue?vue&type=template&id=48721981&scoped=true&"
import script from "./InventoryPrivilegeList.vue?vue&type=script&lang=js&"
export * from "./InventoryPrivilegeList.vue?vue&type=script&lang=js&"
import style0 from "./InventoryPrivilegeList.vue?vue&type=style&index=0&id=48721981&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48721981",
  null
  
)

export default component.exports